/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';

export const getAllItems = () => {
  const items = {} as any;
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key) {
      items[key] = localStorage.getItem(key) || '';
    }
  }
  return items;
};

export const useLocalStorage = (key: string, defaultValue: any = null) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      return getItemFromLocalStorage(key, defaultValue);
    } catch (err) {
      return defaultValue;
    }
  });

  const setValue = (value: unknown) => {
    localStorage.setItem(key, JSON.stringify(value));
    setStoredValue(value);
  };

  return [storedValue, setValue];
};

export const getItemFromLocalStorage = <T>(key: string, defaultValue: unknown = null) => {
  const allItems = getAllItems();

  const value = Object.entries(allItems).find(([keyItem, valueItem]) => {
    if (keyItem.includes(key)) {
      return valueItem;
    }
  });

  if (value && value.length > 0) {
    const result = JSON.parse(value[1] as string) as T;
    return result;
  }

  return defaultValue;
};
